import React from "react"
import autobind from "class-autobind"
import { Paper } from "material-ui"
import { IDate, IJobDocument, EJobDashboardCircleChartType, IJobDashboardChartData, EDashboardDetailType, EFavoriteType } from "../../../../models"
import DaySelect from "../../../../components/common/DaySelect"
import moment from "moment"
import * as utils from "../../../../helpers/utils"
import AccountStore from "../../../../stores/AccountStore"
import { EnumValues } from "enum-values"
import JobDashboardCircleChartFilter from "./JobDashboardCircleChartFilter"
import * as api from "../../../../api"
import strings from "../../../../localization/strings"
import JobDashboardCharts from "./JobDashboardCharts"
import JobDashboardDetail from "./JobDashboardDetail"
import FavoriteSelector from "../../../../components/common/favoriteSelector/FavoriteSelector"
import _ from "lodash"

interface IProps {
    job: IJobDocument
}
interface IState {
    utcTime: IDate
    selectedDay: IDate
    isToday: boolean
    showCircleChartItems: EJobDashboardCircleChartType[]
    loading: boolean
    chartData: IJobDashboardChartData
    activatedTab: EDashboardDetailType
}

export default class JobDashboard extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        const localTime = moment()
        this.state = {
            utcTime: _.cloneDeep(localTime).utc().format(),
            selectedDay: localTime,
            isToday: true,
            showCircleChartItems: this.getShowCircleChartItemsByStorage(),
            loading: true,
            chartData: null,
            activatedTab: EDashboardDetailType.WorkingEmployee,
        }
        autobind(this)
    }

    getShowCircleChartItemsByStorage(): EJobDashboardCircleChartType[] {
        const localStorageKey = "ShowJobDashboardCircleChartFilterItems"
        const storedShowFilterItemsStr = utils.getCookie(localStorageKey)
        const showFilterItems =
            storedShowFilterItemsStr ?
                storedShowFilterItemsStr === "none" ?
                    [] :
                    storedShowFilterItemsStr.split(",") :
                EnumValues.getNames(EJobDashboardCircleChartType)
        return showFilterItems.map(i => EJobDashboardCircleChartType[i]).filter(i => AccountStore.getPhasesEnabled() ? true : i !== EJobDashboardCircleChartType.Phases)
    }

    componentDidMount() {
        this.getChartData()
    }

    getChartData() {
        this.setState({ loading: true }, () =>
            api.getJobDashboardChartData(this.props.job.Id, moment(this.state.selectedDay).utc(true).format(), this.state.isToday, this.state.utcTime, this.state.showCircleChartItems).then(res =>
                this.setState({
                    loading: false,
                    chartData: res.data
                })
            )
        )
    }

    handleChangeSelectedDay(selectedDay: IDate) {
        const selectedDayMoment = moment(selectedDay)
        const localTime = moment()
        const isToday = selectedDayMoment.year() === localTime.year() && selectedDayMoment.month() === localTime.month() && selectedDayMoment.date() === localTime.date()
        this.setState({
            utcTime: _.cloneDeep(localTime).utc().format(),
            selectedDay: isToday ? localTime : moment(selectedDay).endOf("day"),
            isToday
        }, () =>
            this.getChartData()
        )
    }

    render() {
        return (
            <Paper zDepth={1} style={{ margin: 20 }}>
                <div style={{ display: "flex", position: "relative", justifyContent: "center", paddingTop: 20, paddingLeft: 20, paddingRight: 20 }}>
                    <div style={{ fontSize: 25, fontWeight: "bold", position: "absolute", left: 20 }}>
                        {this.props.job.ExternalId ? `${this.props.job.Name} #${this.props.job.ExternalId}` : this.props.job.Name}
                        <span style={{ paddingLeft: 8 }}>
                            <FavoriteSelector
                                itemName={this.props.job.Name}
                                isFavorite={this.props.job.IsFavorite}
                                objectId={this.props.job.Id}
                                favoriteType={EFavoriteType.Job}
                                fontSize={25}
                            />
                        </span>
                    </div>
                    <div style={{ position: "absolute", right: 5, top: 0, display: 'flex' }}>
                        <div
                            title={strings.Refresh}
                            style={{ marginTop: 15 }}
                            onClick={() => this.handleChangeSelectedDay(moment())}
                        >
                            <i style={{ fontSize: 25 }} className="fa fa-refresh itemActionButton" />
                        </div>
                        <JobDashboardCircleChartFilter
                            showCircleChartItems={this.state.showCircleChartItems}
                            handleChange={showCircleChartItems => this.setState({ showCircleChartItems })}
                        />
                    </div>
                </div>
                <div style={{ marginTop: 30, display: "flex", justifyContent: "center" }}>
                    <DaySelect
                        selectedDay={this.state.selectedDay}
                        handleChange={this.handleChangeSelectedDay}
                        limitMaxDay={moment()}
                    />
                </div>
                <JobDashboardCharts
                    loading={this.state.loading}
                    isToday={this.state.isToday}
                    showCircleChartItems={this.state.showCircleChartItems}
                    chartData={this.state.chartData}
                />
                <JobDashboardDetail
                    jobId={this.props.job.Id}
                    utcTime={this.state.utcTime}
                    isToday={this.state.isToday}
                    selectedDay={this.state.selectedDay}
                    activatedTab={this.state.activatedTab}
                    handleChangeActivatedTab={activatedTab => this.setState({ activatedTab })}
                />
            </Paper>
        )
    }
}
